import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { isNil, max, mean } from 'lodash';
import { round } from '../classes/math.utilities';
import { ISHAggregateHitStats } from '../interfaces/session-hits/i-agg-hit-stats';
import { ISessionHit } from '../interfaces/session-hits/i-session-hit';

// for reuse between server and front-end to ensure numbers agree
export class SessionHelper {
  static getHitsStats(hits: ISessionHit[]) {
    const safeHits = hits
      .filter((m) => !m.avg_excluded && !m.hit?.invalid)
      .filter((m) => !!m.hit?.distanceFT) // only actual hits
      .filter((m) => !m.isInGame); // MLB does not allow us to show in-game hit results

    const safeExits = safeHits
      .map((m) => m.hit?.exitMPH)
      .filter((m) => m !== null && m !== undefined) as number[];

    const safeDistances = safeHits
      .map((m) => m.hit?.distanceFT)
      .filter((m) => m !== null && m !== undefined) as number[];

    const safeVLaunches = safeHits
      .map((m) => m.hit?.vLaunchDEG)
      .filter((m) => m !== null && m !== undefined) as number[];

    const output: ISHAggregateHitStats = {
      avgExitMPH: mean(safeExits),
      maxExitMPH: max(safeExits) ?? 0,
      avgDistanceFT: mean(safeDistances),
      maxDistanceFT: max(safeDistances) ?? 0,
      avgVLaunchDeg: mean(safeVLaunches),
    };

    return output;
  }

  /**
   * Turns hit stat into our desired human readable format.
   * Also handles cases where mean (above) returns NaN when it's passed an empty array
   */
  static formatHitStat(
    value: Nullable<number>,
    config?: {
      roundTo?: number;
      fixedTo?: number;
      // e.g. to convert from imperial to metric
      toMetricFn?: (val: number) => number;
    }
  ) {
    if (isNil(value) || isNaN(value)) {
      return '-';
    }

    const stat = config?.toMetricFn ? config.toMetricFn(value) : value;

    if (config?.roundTo !== undefined) {
      return round(stat, config.roundTo);
    }

    if (config?.fixedTo !== undefined) {
      return round(stat, config.fixedTo);
    }

    return stat;
  }
}
